import { PROMOTION_TYPE, RnbCalculatorPayload } from 'typings'
import type { Promotion, PromotionBase } from '../../../typings'
import { toAPIBuyAndWin } from './promotions/buyAndWin'
import { toAPIBuyTogether } from './promotions/buyTogether'
import { toAPIMoreForLess } from './promotions/moreForLess'
import { toAPIProgressiveDiscount } from './promotions/progressiveDiscount'
import { toAPIRegular } from './promotions/regular'
import { toAPIScheduling } from './scheduling'
import { toAPIStorefront } from './storefront'
import { toAPICampaign } from './promotions/campaign'

function removeIncompatibleFields(
  data: RnbCalculatorPayload,
  incompatibleFields: string[]
): RnbCalculatorPayload {
  const result = { ...data }

  incompatibleFields.forEach((field) => {
    delete result[field]
  })

  return result
}

export function toAPIOriginalValues(
  originalValues: RnbCalculatorPayload | undefined,
  incompatibleFields: string[]
) {
  if (originalValues) {
    return removeIncompatibleFields(originalValues, incompatibleFields)
  }
}

export function toAPIPromotionBase(
  data: PromotionBase
): ReturnType<typeof toAPIScheduling & typeof toAPIStorefront> &
  Pick<
    RnbCalculatorPayload,
    'idCalculatorConfiguration' | 'type' | 'name' | 'description' | 'isActive'
  > {
  return {
    idCalculatorConfiguration: data.id ?? '',
    type: data.type,
    name: data.general.name,
    description: data.general.description,
    isActive: data.general.active,
    ...toAPIScheduling(data.scheduling),
    ...toAPIStorefront(data.storefront),
  }
}

export function toAPIPromotion(
  data: Promotion,
  originalValues?: RnbCalculatorPayload
): ReturnType<
  | typeof toAPIBuyTogether
  | typeof toAPIBuyAndWin
  | typeof toAPIPromotionBase
  | typeof toAPIMoreForLess
  | typeof toAPIProgressiveDiscount
  | typeof toAPIRegular
  | typeof toAPICampaign
> {
  switch (data.type) {
    case PROMOTION_TYPE.BUY_TOGETHER:
      return toAPIBuyTogether(data, originalValues)
    case PROMOTION_TYPE.BUY_AND_WIN:
      return toAPIBuyAndWin(data, originalValues)
    case PROMOTION_TYPE.MORE_FOR_LESS:
      return toAPIMoreForLess(data, originalValues)
    case PROMOTION_TYPE.PROGRESSIVE:
      return toAPIProgressiveDiscount(data, originalValues)
    case PROMOTION_TYPE.REGULAR:
      return toAPIRegular(data, originalValues)
    case PROMOTION_TYPE.CAMPAIGN:
      return toAPICampaign(data, originalValues)
  }
}
